(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    function uwantFindReviewTarget(selector) {
    var fallbackSelectors = [
      '#judgeme_product_reviews',
      '.jdgm-widget.jdgm-review-widget',
      '.jdgm-review-widget',
      '.jdgm-rev-widg',
      '.jdgm-widget',
      '#reviews',
      '#review',
      '#product-reviews',
      '#shopify-product-reviews',
      '[data-reviews-section]',
      '.reviews-section',
      '.product-reviews'
    ];

    var target = null;

    if (selector) {
      try {
        target = document.querySelector(selector);
      } catch (error) {
        target = null;
      }
    }

    if (!target) {
      for (var i = 0; i < fallbackSelectors.length; i++) {
        try {
          target = document.querySelector(fallbackSelectors[i]);
        } catch (error) {
          target = null;
        }

        if (target) break;
      }
    }

    return target;
  }

  function uwantGetFixedHeaderOffset() {
    var offset = 0;
    var header = document.querySelector('#site-header, .uwant-header-final, sticky-header, .shopify-section-header-sticky');

    if (header) {
      var style = window.getComputedStyle(header);
      if (style.position === 'fixed' || style.position === 'sticky') {
        offset = header.getBoundingClientRect().height || 0;
      }
    }

    return offset + 12;
  }

  function uwantScrollToReviews(trigger) {
    if (!trigger) return;

    var selector = trigger.getAttribute('data-review-target-selector');
    var target = uwantFindReviewTarget(selector);

    if (!target) {
      window.location.hash = 'judgeme_product_reviews';
      return;
    }

    var top = target.getBoundingClientRect().top + window.pageYOffset - uwantGetFixedHeaderOffset();

    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });

    window.setTimeout(function() {
      if (!target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
      }

      try {
        target.focus({ preventScroll: true });
      } catch (error) {}
    }, 450);
  }

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('.js-rating-scroll-to-reviews');
    if (!trigger) return;

    event.preventDefault();
    uwantScrollToReviews(trigger);
  });

  document.addEventListener('keydown', function(event) {
    var trigger = event.target.closest('.js-rating-scroll-to-reviews');
    if (!trigger) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      uwantScrollToReviews(trigger);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
